import { IListFetcher } from '../fetchers/IListFetcher';
import { ListResult } from '../fetchers/ListResult';
import { IFieldValue } from '../ServerApi/types/IFieldValue';
import { FieldValueResourceType, IFieldValuesParams } from '../ServerApi/types/IFieldValuesParams';
import { ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { formatFilterClauses, getPage } from './ResourceQuery';

export class FieldValuesQuery {

  private filterClauses: ILeafFilterClause[];
  private matchText: string;

  constructor(
    private fetcher: IListFetcher<IFieldValue>,
    private field: string,
    private resourceType?: FieldValueResourceType,
    ) { }

  // Getters

  public getSlice(start: number, size: number): ng.IPromise<ListResult<IFieldValue>> {
    const params: IFieldValuesParams = {
      field: this.field,
      labelMatchText: this.matchText,
      page: getPage(start, size),

      resourceType: this.resourceType,
      resourceCountFilter: formatFilterClauses(this.filterClauses),
    };

    return this.fetcher.fetchList(params);
  }

  public getFilters(): ILeafFilterClause[] {
    return this.filterClauses;
  }

  // Public Clone and Setters

  public withMatchText(matchText: string): FieldValuesQuery {
    return this.clone().setMatchText(matchText);
  }

  public withFilters(filterClauses: ILeafFilterClause[]): FieldValuesQuery {
    return this.clone().setFilterClauses(filterClauses);
  }

  // Private methods

  private clone(): FieldValuesQuery {
    return new FieldValuesQuery(this.fetcher, this.field, this.resourceType)
      .setFilterClauses(this.filterClauses)
      .setMatchText(this.matchText);
  }

  private setFilterClauses(filterClauses: ILeafFilterClause[]): FieldValuesQuery {
    this.filterClauses = filterClauses;
    return this;
  }

  private setMatchText(matchText: string): FieldValuesQuery {
    this.matchText = matchText;
    return this;
  }

}
